import {
  EXPERTS_LOADER,
  SET_EXPERTS_DATA,
  SET_EXPERT_DETAIL_DATA,
} from "../actionTypes";

const initialState = {
  loader: false,
  // expertDetail: {},
  experts: {},
};

const expertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXPERTS_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case SET_EXPERTS_DATA: {
      return {
        ...state,
        experts: action.payload,
      };
    }
    // case SET_EXPERT_DETAIL_DATA: {
    //   return {
    //     ...state,
    //     expertDetail: action.payload,
    //   };
    // }
    default:
      return state;
  }
};

export default expertsReducer;
